import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocalStorage } from "usehooks-ts";
import { Header } from "./components/Header";
import { NETWORKS, SUPPORTED_CHAINIDS } from "./constants/chains";
import { useAllTokens } from "./hooks/useTokens";
import { VaultsBalanceLoader } from "./pages/components/VaultsBalanceLoader";
import { VaultsDetailsLoader } from "./pages/components/VaultsDetailsLoader";
import { VaultsList } from "./pages/VaultsList";
import ListUpdater from "./store/lists/updater";
import { fetchVaultsWhitelist, selectVaultsListEmpty } from "./store/vaults";

enum SortOptions {
  TVL = "TVL",
  APR = "APR",
  BALANCE = "Balance",
}

export function App() {
  const isVaultsListEmpty = useSelector(selectVaultsListEmpty);
  const dispatch = useDispatch();
  const [account, setAccount] = useLocalStorage<string>("account", "");
  const [selectedSortOption, setSelectSortOption] = useState<string>(
    SortOptions.TVL
  );
  const [tokenFilter, setSelectTokenFilter] = useState<string>();
  const [networkFilter, setSelectNetworkFilter] = useState<
    string | undefined
  >();
  const allTokens = useAllTokens();

  // Fetch all vaults list JSON on app load
  useEffect(() => {
    if (isVaultsListEmpty) {
      // @ts-ignore
      dispatch(fetchVaultsWhitelist());
    }
  }, [dispatch, isVaultsListEmpty]);

  function handleClear() {
    setAccount("");
    setSelectSortOption(SortOptions.TVL);
    setSelectTokenFilter("");
    setSelectNetworkFilter("");
  }

  return (
    <div className="App">
      <Header />
      <div className="flex max-w-2xl mx-auto justify-between mt-6">
        {/* Account input */}
        <input
          className="max-w-[230px]"
          onChange={(event) => setAccount(event.target.value)}
          value={account}
          placeholder="Account"
        />
        {/* Sort selectors */}
        <select
          onChange={(event) => setSelectSortOption(event.target.value)}
          value={selectedSortOption}
        >
          <option value={SortOptions.TVL}>{SortOptions.TVL}</option>
          <option value={SortOptions.APR}>{SortOptions.APR}</option>
          <option value={SortOptions.BALANCE}>{SortOptions.BALANCE}</option>
        </select>
        {/* Filter selectors */}
        <select
          onChange={(event) => setSelectTokenFilter(event.target.value)}
          value={tokenFilter}
        >
          <option value="">All Tokens</option>
          {/* Token List */}
          {Object.keys(allTokens).map((address: any) => (
            <option
              key={allTokens[address].symbol}
              value={allTokens[address].wrapped.address}
            >
              {allTokens[address].symbol}
            </option>
          ))}
        </select>
        <select
          onChange={(event) => setSelectNetworkFilter(event.target.value)}
          value={networkFilter}
        >
          <option value="">All Networks</option>
          {/* Network List */}
          {SUPPORTED_CHAINIDS.map((chainId) => (
            <option key={chainId} value={chainId}>
              {NETWORKS[chainId].name}
            </option>
          ))}
        </select>
        <button onClick={handleClear}>Clear</button>
        {SUPPORTED_CHAINIDS.map((chainId) => (
          <VaultsDetailsLoader key={chainId} chainId={chainId} />
        ))}
      </div>
      {SUPPORTED_CHAINIDS.map((chainId) => (
        <ListUpdater key={chainId} chainId={chainId} />
      ))}
      {account &&
        SUPPORTED_CHAINIDS.map((chainId) => (
          <VaultsBalanceLoader
            key={chainId}
            chainId={chainId}
            account={account}
          />
        ))}
      <VaultsList
        sortOption={selectedSortOption}
        tokenFilter={tokenFilter}
        networkFilter={networkFilter}
      />
    </div>
  );
}
